import { gql } from '@apollo/client'

const ACTIVITY_FIELDS = gql`
  fragment ActivityFields on ActivityItem {
    id
    routing_key
    keys
    actor {
      type
      id
      label
    }
    action
    resource {
      type
      id
      label
    }
    context {
      parent_accounts
      site_accounts
      params
      removed_accounts
      added_accounts
    }
    diff {
      attribute
      old_value
      new_value
    }
    app_id
    app_fqdn
    correlation_id
    sent_at
    created_at
  }
`

export const GET_USER_RESOURCE_ACTIVITY = gql`
  query GetUserResourceActivity($resourceClass: String!, $resourceAttribute: String!, $resourceValue: String!) {
    activity: getUserResourceActivity(resource: {
      class: $resourceClass,
      attribute: $resourceAttribute,
      value: $resourceValue
    }) {
      ...ActivityFields
    }
  }
  ${ACTIVITY_FIELDS}
`

export const GET_USER_ACTOR_ACTIVITY = gql`
  query GetUserActorActivity($actorClass: String!, $actorAttribute: String!, $actorValue: String!) {
    activity: getUserActorActivity(actor: {
      class: $actorClass,
      attribute: $actorAttribute,
      value: $actorValue
    }) {
      ...ActivityFields
    }
  }
  ${ACTIVITY_FIELDS}
`

export const GET_CONTACT_RESOURCE_ACTIVITY = gql`
  query GetContactResourceActivity($resourceClass: String!, $resourceAttribute: String!, $resourceValue: String!) {
    activity: getUserResourceActivity(resource: {
      class: $resourceClass,
      attribute: $resourceAttribute,
      value: $resourceValue
    }) {
      ...ActivityFields
    }
  }
  ${ACTIVITY_FIELDS}
`

export const GET_CONTACT_ACTOR_ACTIVITY = gql`
  query GetContactActorActivity($actorClass: String!, $actorAttribute: String!, $actorValue: String!) {
    activity: getUserActorActivity(actor: {
      class: $actorClass,
      attribute: $actorAttribute,
      value: $actorValue
    }) {
      ...ActivityFields
    }
  }
  ${ACTIVITY_FIELDS}
`
